import { Phone, Menu, X, ShoppingCart } from "lucide-react";
import { useState } from "react";
import { COMPANY } from "@/lib/content";
import { useCart } from "@/lib/cart";

export default function Navbar({ scrolled }) {
  const [open, setOpen] = useState(false);
  const { count, setOpen: setCartOpen } = useCart();

  const links = [
    { href: "#szolgaltatasok", label: "Szolgáltatások" },
    { href: "#webshop", label: "Webshop" },
    { href: "#arkalkulator", label: "Árkalkulátor" },
    { href: "#flotta", label: "Flotta" },
    { href: "#kapcsolat", label: "Kapcsolat" },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 will-change-transform ${
        scrolled
          ? "bg-[#F0F1F5]/95 backdrop-blur-md border-b border-gray-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="relative w-9 h-9 grid place-items-center rounded-sm bg-gradient-to-br from-blue-600 to-violet-600 glow-blue">
            <span className="font-display font-bold text-gray-900 text-sm">PT</span>
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display text-base font-bold tracking-tight">PITSTOP TIRE</span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-violet-600/80">Nonstop · Budapest</span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 transition-colors uppercase tracking-wider font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="nav-cart-btn"
            onClick={() => setCartOpen(true)}
            className="relative inline-flex items-center justify-center w-11 h-11 border border-gray-200 bg-gray-50 hover:border-violet-400 rounded-sm transition-all"
            aria-label="Kosár"
          >
            <ShoppingCart className="w-4 h-4 text-gray-600" />
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1 grid place-items-center text-[10px] font-bold bg-gradient-to-br from-blue-500 to-violet-500 text-white rounded-full">
                {count}
              </span>
            )}
          </button>
          <a
            href={`tel:${COMPANY.phoneRaw}`}
            data-testid="nav-call-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-violet-600 text-white font-bold text-sm tracking-wide rounded-sm hover:from-blue-500 hover:to-violet-500 transition-all glow-blue"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <button
            data-testid="nav-cart-btn-mobile"
            onClick={() => setCartOpen(true)}
            className="relative inline-flex items-center justify-center w-10 h-10 border border-gray-200 bg-gray-50 rounded-sm"
            aria-label="Kosár"
          >
            <ShoppingCart className="w-4 h-4 text-gray-600" />
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 grid place-items-center text-[9px] font-bold bg-gradient-to-br from-blue-500 to-violet-500 text-white rounded-full">
                {count}
              </span>
            )}
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="p-2 text-gray-900"
            onClick={() => setOpen(!open)}
            aria-label="Menü"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-gray-200 bg-[#F0F1F5]/95 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm uppercase tracking-wider text-gray-600 hover:text-gray-900 border-b border-gray-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${COMPANY.phoneRaw}`}
              className="mt-3 inline-flex items-center justify-center gap-2 px-5 py-3 bg-gradient-to-r from-blue-600 to-violet-600 text-white font-bold text-sm rounded-sm"
            >
              <Phone className="w-4 h-4" /> {COMPANY.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
